import { useEffect, useState } from "react";
import { RouteLineContext } from "./RouteLineContext";
import { RouteLine } from "../../../types/RouteLine/RouteLine";

interface RouteLineProviderProps {
  children: React.ReactNode;
}

const RouteLineProvider = ({ children }: RouteLineProviderProps) => {
  const [routeLines, setRouteLines] = useState<RouteLine[] | null>(null);
  const [selectedRouteLine, setSelectedRouteLine] = useState<RouteLine | null>(
    null,
  );
  const [showOverlay, setShowOverlay] = useState(false);

  useEffect(() => {
    if (routeLines === null) {
      setSelectedRouteLine(null);
    } else {
      setSelectedRouteLine(routeLines[0] ?? null);
      setShowOverlay(false);
    }
  }, [routeLines]);

  return (
    <RouteLineContext.Provider
      value={{
        routeLines,
        setRouteLines,
        selectedRouteLine,
        setSelectedRouteLine,
        showOverlay,
        setShowOverlay,
      }}
    >
      {children}
    </RouteLineContext.Provider>
  );
};

export default RouteLineProvider;
